module.exports = __webpack_public_path__ + "static/img/shnaghai.3f20519.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/aboutUs/shnaghai.png
// module id = gvYP
// module chunks = 1